<template>
  <div class="rolemanagetable">
    <el-table :data="tableData"
              style="width: 100%;padding:10px 10px 0 10px;"
              border>
      <el-table-column prop="createAtMY"
                       label="打包时间"
                        width="140">
      </el-table-column>
      <el-table-column prop="title"
                       label="标题"
                       :show-overflow-tooltip="true">
      </el-table-column>

      <el-table-column prop="size"
                       label="压缩包大小">
        <!-- <template slot-scope="scope">
          <div>暂无数据</div>
        </template> -->
      </el-table-column>

      <el-table-column prop="statusTitle"
                       label="打包状态"
                        width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'success'">
            <el-tag type="success">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'error' ">
            <el-tag type="danger">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'none'">
            <el-tag type="info">打包中……</el-tag>
          </div>

          <div v-if="scope.row.status === 'warn'">
            <el-tag type="warning">{{scope.row.statusTitle}}</el-tag>
          </div>

        </template>
      </el-table-column>
      <el-table-column prop="downloadCount"
                       label="下载次数" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.downloadCount==0?'info':''">{{ scope.row.downloadCount }}次</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作"
                       width="300">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.status !== '失败' && scope.row.status !== '打包中……'">
            <el-button @click="openClick(scope)" type="text" class="btn" size="small">下载链接</el-button>
            <span style="margin:0 8px;"> | </span>
            <el-button @click="changeClick(scope)" type="text" class="btn" size="small">二维码</el-button>
          </div> -->

          <div style="display:flex;align-items: center;">
            <span v-if="scope.row.status === 'error' ">
              <el-button @click="closeClick(scope)"
                         type="text"
                         class="btn"
                         size="small">重新打包</el-button>

            </span>

            <span v-if="scope.row.status === 'warn'">
              <div>请等待打包结束！</div>
            </span>

            <span v-if="scope.row.status === 'none'">
              <div>无</div>
            </span>
            <span v-if="scope.row.status === 'success'">
              <el-button v-if="isPointsEnable=='true'" @click="openBoxOfDownLoad(scope.row)"  style="color:#13aa65;font-weight:bold;font-size:13px;" type="text" class="btn" size="small">
                <i class="el-icon-download"></i>
                点击下载
              </el-button>
              <el-button v-if="isPointsEnable=='false'" @click="openBoxOfDownLoad(scope.row)"  style="color:#13aa65;font-weight:bold;font-size:13px;" type="text" class="btn" size="small">
                <i class="el-icon-download"></i>
                点击下载
              </el-button>
              <!-- <a v-else :href="picPrefix+scope.row.downloadUrl"
                 style="color: #185ED3;"
                 target="_blank">
                <i class="el-icon-download"></i>
                点击下载</a> -->

            </span>
            <span style="margin:0 11px;"> | </span>

            <span>
              <el-button @click="seePic(scope)"
                         type="text"
                         style="color:#3086F0;font-weight:bold;font-size:13px;"
                         class="btn"
                         size="small"><i style="margin-right:3px;"
                   class="el-icon-picture-outline"></i>查看资源</el-button>
            </span>
            <span style="margin:0 11px;"> | </span>
            <span>
              <el-button @click="deleteRecord(scope)"
                         type="text"
                         style="color:#3086F0;font-weight:bold;font-size:13px;"
                         class="btn"
                         size="small"><i style="margin-right:3px;"
                   class="el-icon-picture-outline"></i>删除记录</el-button>
            </span>
          </div>
        </template>

      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { picPrefix } from "@/constants/piccommon"
import { deletePicturePackage,downPackage } from "@/api/picturePackage"
import { downLoadFile } from "@/plugins/util.js"
export default {
  name: 'rolemanagetable',
  props: {
    tableData: Array,
  },
  data () {
    return {
      picPrefix,
      isPointsEnable:''
      // tableData:[
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     size:'0M',
      //     state:'失败'
      //   },
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     size:'0M',
      //     state:'打包中……'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'23',
      //     size:'45M',
      //     state:'成功'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'45',
      //     size:'564M',
      //     state:'2000次'
      //   },
      // ]
    }
  },
  methods: {
    // 打开下载确认盒子
    openBoxOfDownLoad(rowData) {
      if (this.isPointsEnable=='true') {
        if (rowData.downloadCount==0) {
          this.$confirm(`首次下载本资源需要花费${rowData.downloadPoints}积分，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
            this.pointDownLoad(rowData)
          // this.deletePicturePackageAsync(scope)
          }).catch(() => {
            this.$message.info('取消操作')

          });
        } else {
          this.pointDownLoad(rowData)
          // this.$message('不是第一次下载直接调下载接口')
        }
      } else {
        this.pointDownLoad(rowData)
      }
    },
    // 积分下载压缩文件方法
    async  pointDownLoad(rowData) { 
      let {status,message,data} = await downPackage({ id:rowData.id })
      if (status) {
        this.$message.success({ message: `${message}请耐心等待...` })
        setTimeout(() => {
          this.$parent.refresh()
        },1000)
        let downLoadUrl = this.picPrefix + rowData.downloadUrl;
        console.log(downLoadUrl);
        let a = document.createElement("a");
        a.href = downLoadUrl;
        window.open(a.href, '_blank');
        // downLoadFile(downLoadUrl,rowData.title)
      } else {
        this.$message.error(message)
      }
    },
    
    deleteRecord (scope) {
      // console.log(scope.$index);
      // console.log(scope);
      // console.log(this.tableData);
      // return
      this.$confirm('确认删除本条下载记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletePicturePackageAsync(scope)
      }).catch(() => {
      });

    },
    async deletePicturePackageAsync (scope) {
      let { status, data, message } = await deletePicturePackage(scope.row.id)
      if (status) {
        this.$message.success('删除成功！')
        this.tableData.splice(scope.$index, 1)
        console.log(this.tableData);
      } else {
        this.$message.error('删除失败！')
      }
    },
    openClick (scope) {

    },
    closeClick (scope) {

    },
    changeClick (scope) {
      this.$emit('changeClick', scope)
    },
    seePic (scope) {
      this.$emit('seePic', scope)
    },
    removeClick (scope) {
      this.$emit('removeClick', scope)
    },
  },
  created () {
    this.isPointsEnable=localStorage.getItem('isPointsEnable')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
a:link {
  text-decoration: none;
}
a:active {
  text-decoration: blink;
}
a:hover {
  text-decoration: underline;
}
a:visited {
  text-decoration: none;
}
.btn:hover {
  text-decoration: underline;
}
</style>
